import { Center, Container, Grid, Heading } from '@chakra-ui/react';
import { ReactElement } from 'react';

function NotFound(): ReactElement {

    return (
        <Grid minHeight="100vh">
            <Center>
                <Container>
                    <Heading>Pagina no encontrada</Heading>
                </Container>
            </Center>
        </Grid>
    );
}

export default NotFound;
